(function () {
    'use strict';

    angular.module("imApp").factory("interBranchInvoiceLineService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 803,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 804,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
